import * as yup from 'yup';

export const CompanyDetailsValidationSchema = yup.object().shape(
	{
		referenceNumber: yup
			.string()
			.nullable()
			.max(150, 'Reference Number must be less than 150 Characters'),
		companyName: yup
			.string()
			.nullable()
			.required('Company Name is required')
			.max(150, 'Company Name must be less than 150 Characters'),
		tradingAs: yup
			.string()
			.nullable()
			.max(150, 'Trading As must be less than 150 Characters'),
		companyTypeId: yup
			.number()
			.nullable()
			.transform((curr, orig) => (orig === '' ? null : curr)),
		registrationNumber: yup
			.string()
			.nullable()
			.required('Registration Number is required')
			.transform((curr, orig) => (orig === '' ? null : curr))
			.max(15, 'Registration Number must be less than/equal to 15 Characters')
			.matches(/^(?:\d{4}\/\d{6}\/\d{2}|IT\d{4}\/\d{4}|\d{3}-\d{3}|\d{13})$/, 'Invalid company registration number. Company Registration number: Format = xxxx/xxxxxx/xx or ID number: Format = xxxxxxxxxxxxx or Trust number: Format = ITxxxx/xxxx or 6 Digit NPO number: Format = xxx-xxx'),
		vatNumber: yup
			.string()
			.nullable()
			.transform((curr, orig) => (orig === '' ? null : curr))
			.max(10, 'VAT Number must be less than/equal to 10 Characters')
			.matches(/^\d+$/, 'VAT Number should have digits only'),
		addressLine1: yup.string().nullable(),
		addressLine2: yup.string().nullable(),
		suburb: yup
			.object()
			.shape({
				Id: yup.string(),
				Name: yup.string(),
			})
			.nullable(),
		province: yup
			.object()
			.shape({
				Id: yup.string(),
				Name: yup.string(),
			})
			.nullable(),
		code: yup
			.string()
			.nullable()
			.transform((curr, orig) => (orig === '' ? null : curr))
			.min(4, 'Invalid Postal Code')
			.max(4, 'Invalid Postal Code')
			.matches(/^\d+$/, 'Postal Code should have digits only'),
	}
	// [['EmployeeCode', 'IdentificationNumber']]
);